import { Schema, type } from "@colyseus/schema";

/**
 * Per-player expertise SPEND-state (B5 progression).
 *
 * The raw earned XP counter stays on Cube (`cube.xp`, referenced by 20+ award /
 * display sites); this sub-schema holds how that XP has been converted into a
 * character level, banked (unspent) points, and per-tree investments.
 *
 * Nested on Cube as `cube.expertise` so the 7 fields cost ONE Cube schema slot —
 * the Cube is at @colyseus/schema's hard 64-field cap (see the KoboldMeta
 * docstring in state.ts for why 65 fields silently corrupts decode). Room was
 * freed by dropping the never-used RESERVED `spellEvasion`/`spellEvasionMod`
 * pair (zero readers anywhere; trivially re-addable if a future spell needs it).
 *
 * Compressed 5-tier model (docs/design/05-heroes-progression.md): each tree has
 * 5 tiers; 1 point granted per level-up; each v1 tier = 5 KTS skill-levels of
 * stats (×5 coefficients) + that band's KTS perk. getExpertiseLevel(cube, tree)
 * reads the tier (0..5) off these fields.
 */
export class Expertise extends Schema {
  @type("uint8") characterLevel = 1; // 1..LEVEL_CAP (10)
  @type("uint8") bankedPoints = 0;   // unspent expertise points
  @type("uint8") forestry = 0;       // 0..5 tier
  @type("uint8") mining = 0;
  @type("uint8") cooking = 0;
  @type("uint8") foraging = 0;
  @type("uint8") artisanship = 0;
}
